import React from "react";
import Bredcom from "../../Bradcom/CamasDoblesB";
import First from "../../Menrooms/Menroomdeatils/CamasDobles";
import { Helmet } from "react-helmet-async";

const Main = () => {
  return (
    <>
      <Helmet>
        <title>Hotel La Finca Zotoluca | Habitación con Camas Dobles</title>
        <meta
          name="description"
          content="Disfruta de una estancia cómoda y placentera en nuestra espaciosa habitación con dos camas dobles, pensada para familias o grupos pequeños que desean compartir momentos sin sacrificar privacidad ni comodidad."
        />
      </Helmet>
      <main>
        <Bredcom
          title={"Habitación con Camas Dobles"}
          subtitle={"Inicio"}
          newtitle={"Habitación con Camas Dobles"}
        />
        <First />
      </main>
    </>
  );
};

export default Main;
